import './Lazy.css';

export default () => {};
